import { render, staticRenderFns } from "./TheLessonAltered.vue?vue&type=template&id=84499f14&scoped=true&"
import script from "./TheLessonAltered.vue?vue&type=script&lang=js&"
export * from "./TheLessonAltered.vue?vue&type=script&lang=js&"
import style0 from "./TheLessonAltered.vue?vue&type=style&index=0&id=84499f14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84499f14",
  null
  
)

export default component.exports